// Klaviyo footer newsletter form
(function () {
  var API_URL = 'https://a.klaviyo.com/client/subscriptions/';
  var API_REVISION = '2026-07-15';
  var SUBMITTED_KEY = 'jamestowne_newsletter_submitted';

  function initNewsletter() {
    var form = document.getElementById('footer-subscribe');
    if (!form) return;

    var emailInput = document.getElementById('footer-subscribe-email');
    var honeypot = form.querySelector('.subscribe__honeypot');
    var button = form.querySelector('.subscribe__btn');
    var message = document.getElementById('footer-subscribe-status');
    var companyId = form.dataset.klaviyoCompanyId;
    var listId = form.dataset.klaviyoListId;

    function showMessage(text, type) {
      message.textContent = text;
      message.classList.remove('is-success', 'is-error');
      if (type) message.classList.add('is-' + type);
    }

    function setSubmitting(isSubmitting) {
      button.disabled = isSubmitting;
      form.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
    }

    function rememberSubmission() {
      try {
        sessionStorage.setItem(SUBMITTED_KEY, 'true');
      } catch (error) {
        // The visual success state still works when browser storage is unavailable.
      }
    }

    function wasSubmitted() {
      try {
        return sessionStorage.getItem(SUBMITTED_KEY) === 'true';
      } catch (error) {
        return false;
      }
    }

    function showSuccess() {
      form.dataset.submitted = 'true';
      form.classList.add('is-success');
      form.reset();
      rememberSubmission();
      showMessage('Thank you for subscribing!', 'success');
    }

    if (wasSubmitted()) showSuccess();

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      if (button.disabled || form.dataset.submitted === 'true') return;

      if (honeypot && honeypot.value) {
        showSuccess();
        return;
      }

      if (!emailInput.checkValidity()) {
        emailInput.reportValidity();
        return;
      }

      var email = emailInput.value.trim();
      setSubmitting(true);
      showMessage('Joining…');

      try {
        var response = await fetch(API_URL + '?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
            'revision': API_REVISION
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Website footer',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      subscriptions: {
                        email: {
                          marketing: {
                            consent: 'SUBSCRIBED'
                          }
                        }
                      }
                    }
                  }
                }
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: listId
                  }
                }
              }
            }
          })
        });

        if (!response.ok) throw new Error('Klaviyo subscription failed');

        showSuccess();
      } catch (error) {
        showMessage('Something went wrong. Please try again.', 'error');
      } finally {
        setSubmitting(false);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewsletter);
  } else {
    initNewsletter();
  }
})();
